import { COMPANY_TYPES } from "interfaces";

export const getCompanyType = (regNum: string) => {
  switch (regNum.length) {
    case 13:
      return COMPANY_TYPES.COMPANY;
    case 15:
      return COMPANY_TYPES.IP;
    default:
      return null;
  }
};
